import clsx from 'clsx';
import type { CSSProperties } from 'react';

import styles from './Skeleton.module.css';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: string;
  text?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Skeleton({ width, height, radius, text = false, className, style }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={clsx(styles.skeleton, text && styles.text, className)}
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}
